export default __webpack_public_path__ + "static/media/4.6996d45f.png";